// Catálogo único dos atalhos de nós do canvas. Alimenta o painel
// "Adicionar nó" e o seletor "O que acontece depois?". Só inclui ações e
// gatilhos executados por Talkvia::FunnelExecutionService.

export const NODE_SHORTCUT_GROUPS = [
  { id: 'triggers', label: 'Gatilhos', icon: 'i-hugeicons-play' },
  { id: 'messages', label: 'Mensagens', icon: 'i-hugeicons-message-01' },
  { id: 'service', label: 'Atendimento', icon: 'i-hugeicons-user-check-01' },
  { id: 'data', label: 'Dados', icon: 'i-hugeicons-tag-01' },
  { id: 'integrations', label: 'Integrações', icon: 'i-hugeicons-api' },
  { id: 'corban', label: 'Corban', icon: 'i-hugeicons-bank' },
  { id: 'control', label: 'Controle', icon: 'i-hugeicons-git-branch' },
];

export const CORBAN_ACTION_TYPES = [
  'run_credit_engine',
  'request_best_offer',
  'create_contract',
];

export const PRIORITY_OPTIONS = [
  { value: 'low', label: 'Baixa' },
  { value: 'medium', label: 'Média' },
  { value: 'high', label: 'Alta' },
  { value: 'urgent', label: 'Urgente' },
];

const trigger = (triggerType, title, description, icon) => ({
  id: `trigger-${triggerType}`,
  group: 'triggers',
  type: 'trigger',
  triggerType,
  actionType: 'none',
  title,
  description,
  icon,
  color: 'emerald',
});

const action = (group, actionType, title, description, icon, color) => ({
  id: `action-${actionType}`,
  group,
  type: 'action',
  actionType,
  title,
  description,
  icon,
  color,
  corban: CORBAN_ACTION_TYPES.includes(actionType),
});

const control = (type, title, description, icon, color) => ({
  id: `control-${type}`,
  group: 'control',
  type,
  actionType: 'none',
  title,
  description,
  icon,
  color,
});

export const NODE_SHORTCUTS = [
  trigger(
    'conversation_created',
    'Cliente iniciou conversa',
    'Começa quando uma nova conversa é aberta.',
    'i-hugeicons-message-add-01'
  ),
  trigger(
    'message_contains',
    'Mensagem contém palavra',
    'Começa quando a mensagem recebida tiver a palavra-chave.',
    'i-hugeicons-message-search-01'
  ),
  trigger(
    'label_added',
    'Etiqueta adicionada',
    'Começa quando a conversa recebe uma etiqueta.',
    'i-hugeicons-tag-01'
  ),
  trigger(
    'inbox_changed',
    'Caixa alterada',
    'Começa quando a conversa passa para uma caixa de entrada.',
    'i-hugeicons-inbox-download'
  ),
  trigger(
    'webhook_received',
    'Webhook recebido',
    'Começa ao receber um JSON externo no endereço do nó.',
    'i-hugeicons-webhook'
  ),
  action(
    'messages',
    'send_message',
    'Enviar mensagem',
    'Responde ao cliente usando texto e campos do JSON.',
    'i-hugeicons-message-01',
    'blue'
  ),
  action(
    'messages',
    'send_file',
    'Enviar arquivo',
    'Envia um arquivo com legenda opcional.',
    'i-hugeicons-attachment-01',
    'blue'
  ),
  action(
    'messages',
    'send_whatsapp_flow',
    'Enviar WhatsApp Flow',
    'Envia um formulário do WhatsApp Flows dentro da janela de 24 horas.',
    'i-hugeicons-workflow-square-06',
    'emerald'
  ),
  action(
    'messages',
    'add_private_note',
    'Nota privada',
    'Registra uma nota visível apenas para a equipe.',
    'i-hugeicons-note-edit',
    'amber'
  ),
  action(
    'service',
    'assign_human',
    'Chamar atendimento humano',
    'Remove o bot e abre a conversa para a equipe.',
    'i-hugeicons-user-check-01',
    'amber'
  ),
  action(
    'service',
    'assign_team',
    'Atribuir equipe',
    'Direciona a conversa para uma equipe da conta.',
    'i-hugeicons-user-group',
    'violet'
  ),
  action(
    'service',
    'set_priority',
    'Definir prioridade',
    'Altera a prioridade da conversa.',
    'i-hugeicons-flag-02',
    'ruby'
  ),
  action(
    'service',
    'move_inbox',
    'Mover para caixa',
    'Leva a conversa para outra caixa de entrada do contato.',
    'i-hugeicons-inbox',
    'slate'
  ),
  action(
    'data',
    'add_label',
    'Adicionar etiqueta',
    'Marca a conversa com uma etiqueta.',
    'i-hugeicons-tag-01',
    'emerald'
  ),
  action(
    'data',
    'remove_label',
    'Remover etiqueta',
    'Retira uma etiqueta da conversa.',
    'i-hugeicons-tag-02',
    'slate'
  ),
  action(
    'integrations',
    'http_request',
    'Requisição HTTP',
    'Chama uma API externa e guarda a resposta para os próximos nós.',
    'i-hugeicons-api',
    'blue'
  ),
  action(
    'corban',
    'run_credit_engine',
    'Executar motor de crédito',
    'Avalia elegibilidade e segue pelo resultado do motor.',
    'i-hugeicons-dashboard-speed-01',
    'violet'
  ),
  action(
    'corban',
    'request_best_offer',
    'Buscar melhor oferta',
    'Marca o cliente para simulação e melhor oferta.',
    'i-hugeicons-bank',
    'emerald'
  ),
  action(
    'corban',
    'create_contract',
    'Gerar contrato/formalização',
    'Avança o atendimento para geração de contrato.',
    'i-hugeicons-contracts',
    'violet'
  ),
  control(
    'wait',
    'Espera',
    'Aguarda alguns minutos antes da próxima etapa.',
    'i-hugeicons-clock-01',
    'amber'
  ),
  control(
    'decision',
    'Condição',
    'Compara dados do contato, da conversa ou de uma API e segue por Sim ou Não.',
    'i-hugeicons-git-branch',
    'slate'
  ),
  control(
    'offer',
    'Oferta',
    'Etapa visual de oferta no funil.',
    'i-hugeicons-discount-tag-01',
    'emerald'
  ),
  control(
    'end',
    'Fim',
    'Encerra visualmente o caminho do fluxo.',
    'i-hugeicons-flag-03',
    'slate'
  ),
];

const normalizeSearch = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

// context 'panel': todos os atalhos; 'next': sem gatilhos (não seguem um nó).
export const availableNodeShortcuts = ({
  hasCorban = false,
  context = 'panel',
} = {}) =>
  NODE_SHORTCUTS.filter(
    shortcut =>
      (hasCorban || !shortcut.corban) &&
      (context !== 'next' || shortcut.type !== 'trigger')
  );

export const filterNodeShortcuts = (shortcuts, query) => {
  const term = normalizeSearch(query);
  if (!term) return shortcuts;
  const groupLabels = Object.fromEntries(
    NODE_SHORTCUT_GROUPS.map(group => [group.id, group.label])
  );
  return shortcuts.filter(shortcut =>
    [shortcut.title, shortcut.description, groupLabels[shortcut.group]].some(
      value => normalizeSearch(value).includes(term)
    )
  );
};

export const groupNodeShortcuts = shortcuts =>
  NODE_SHORTCUT_GROUPS.map(group => ({
    ...group,
    items: shortcuts.filter(shortcut => shortcut.group === group.id),
  })).filter(group => group.items.length);

export const isCorbanActionType = actionType =>
  CORBAN_ACTION_TYPES.includes(actionType);
